export interface CompanyGeneralFormType
    extends Omit<MyBrokerApi.MoralGeneralForm, "foundationDate" | "lastStatuteChangeDate" | "language"> {
    foundationDate: Date | null;
    lastStatuteChangeDate: Date | null;
    language: string; // IdNamePair
}

export const companyGeneralDefaultValues = (defaultValues: MyBrokerApi.MoralGeneral = {}): CompanyGeneralFormType => {
    const {
        name,
        legalForm,
        foundationDate,
        lastStatuteChangeDate,
        language,
        nationality,
        enterpriseNumber,
        establishmentNumber,
        nssoRegistrationNumber,
        amountOfStaff,
        amountOfEmployees,
        amountOfWorkers,
    } = defaultValues;

    return {
        name: name || "",
        legalForm: legalForm?.id || "",
        foundationDate: foundationDate || null,
        lastStatuteChangeDate: lastStatuteChangeDate || null,
        language: language?.id || "",
        nationality: nationality?.id || "",
        enterpriseNumber: enterpriseNumber || "",
        establishmentNumber: establishmentNumber || "",
        nssoRegistrationNumber: nssoRegistrationNumber || "",
        amountOfStaff: amountOfStaff || null,
        amountOfEmployees: amountOfEmployees || null,
        amountOfWorkers: amountOfWorkers || null,
    };
};

export const companyGeneralFixture = (): CompanyGeneralFormType => ({
    name: "Company name",
    legalForm: "93",
    foundationDate: new Date(2022, 2, 2),
    lastStatuteChangeDate: new Date(2022, 2, 2),
    language: "1",
    nationality: "B",
    enterpriseNumber: "123456789A",
    establishmentNumber: "123456789B",
    nssoRegistrationNumber: "123456789C",
    amountOfStaff: 1,
    amountOfEmployees: 1,
    amountOfWorkers: 1,
});
